import PickArtistAndDate from 'components/HappeningNonContent/ServiceBooking/PickArtistDateTime/PickArtistDateTime';

export default PickArtistAndDate;
